import { render } from "./modalTrainerRating.vue?vue&type=template&id=6a90de26&scoped=true"
import script from "./modalTrainerRating.vue?vue&type=script&lang=js"
export * from "./modalTrainerRating.vue?vue&type=script&lang=js"

import "./modalTrainerRating.vue?vue&type=style&index=0&id=6a90de26&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a90de26"]])

export default __exports__